import React, { useEffect, useState } from "react";
import CardComponent from "../cardComponents/CardComponent";
import AccordionComponent from "../accordion/AccordionComponent";
// import { CreditCardData } from './CardData'
import Http from "../../Http";
import { CARD_API } from "../../Helper";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";
import {
  FaUserCheck,
  FaIdCard,
  FaExternalLinkAlt,
  FaListAlt,
  FaCheckCircle,
  FaFileUpload,
} from "react-icons/fa";
import FAQSchema from "../../FAQSchema";
import { BadgeCheck, FileText } from "lucide-react";
import AdBanner from "../AdPage/AdBanner";
const Rbl = () => {
  const [CreditCardData, setCreditCardData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [cardsPerPage] = useState(10);
  const [activeIndex, setActiveIndex] = useState(0);

  const toggleAccordion = (index) => {
    if (activeIndex === index) {
      // If the clicked question is already expanded, collapse it
      setActiveIndex(null);
    } else {
      // If the clicked question is not expanded, expand it
      setActiveIndex(index);
    }
  };
  function Icon({ id, open }) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={2}
        stroke="currentColor"
        className={`${
          id === open ? "rotate-180" : ""
        } h-5 w-5 transition-transform`}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M19.5 8.25l-7.5 7.5-7.5-7.5"
        />
      </svg>
    );
  }

  useEffect(() => {
    Http.post(CARD_API)
      .then((res) => {
        setCreditCardData(res);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  const indexOfLastCard = currentPage * cardsPerPage;
  const indexOfFirstCard = indexOfLastCard - cardsPerPage;
  console.log({ indexOfLastCard, indexOfFirstCard });
  // const currentCards = CreditCardData.cards
  //   ?.filter((card) => card.category === "Credit card")
  //   .slice(indexOfFirstCard, indexOfLastCard);
  // console.log({ currentCards });
  const currentCards = CreditCardData.cards
  ?.filter((card) => card.title?.toLowerCase().includes("rbl"))
  .slice(indexOfFirstCard, indexOfLastCard);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const faqs = [
    {
      question: "Which is the best RBL card for entertainment perks?",
      answer:
        "   The RBL Popcorn Credit Card offers free movie tickets, making it great for cinema lovers.",
    },
    {
      question: "Is there a lifetime free card from RBL?",
      answer:
        "   Yes, select cards like the RBL Bank Edition Classic may come with zero annual fees depending on usage patterns and offers.",
    },
    {
      question: "Does RBL offer EMI on purchases?",
      answer:
        " Absolutely. Purchases above a certain limit can be converted into easy EMIs with flexible tenure options.",
    },
    {
      question: "How long does approval take after applying?",
      answer:
        " Once documents are verified, approval usually takes 3–5 business days, and delivery follows within 7–10 days.",
    },
    {
      question: "Are there travel benefits with RBL credit cards?",
      answer:
        "  Yes, premium RBL cards may offer complimentary lounge access, fuel surcharge waivers, and travel insurance.",
    },
  ];

  const steps = [
    {
      icon: <FaCheckCircle className="h-6 w-6 text-orange-500" />,
      title: "Check Your Eligibility",
      description:
        "   Match your income, credit score, and location against the card's eligibility criteria before applying.",
    },
    {
      icon: <FaFileUpload className="h-6 w-6 text-green-500" />,
      title: "Prepare Your Documents",
      description:
        "   Click on “Apply Now” to be securely redirected to RBL Bank’s official credit card application page, where you can complete the final steps.",
    },
    {
      icon: <FaExternalLinkAlt className="h-6 w-6 text-purple-600" />,
      title: "Redirect to RBL's Official Portal",
      description:
        "  Click on “Apply Now” to be securely redirected to RBL Bank’s official credit card application page, where you can complete the final steps.",
    },
    {
      icon: <FaListAlt className="h-6 w-6 text-teal-500" />,
      title: "Explore & Compare with TheFinMaster",
      description:
        "  Visit TheFinMaster to explore a curated selection of RBL Bank credit cards, complete with detailed reward structures, fees, eligibility guidelines, and lifestyle fitment. We help you compare options effortlessly.",
    },
  ];
  return (
    <>
      <Helmet>
        <title>
        RBL Bank Credit Cards – Best Offers & Apply Online
        </title>
        <meta
          name="description"
          content="Choose from a range of RBL Bank credit cards with attractive offers. Compare features and apply online today."
        />
        <meta
          name="keywords"
          content="abank of baroda lifetime free credit card, bob easy credit card apply, bank of baroda hpcl credit card, bank of baroda snapdeal credit card, bobcard payment"
        />
        <link
          rel="canonical"
          href="https://thefinmaster.com/rbl-bank/credit-card"
        />
        <meta
          name="robots"
          content="max-snippet:-1, max-image-preview:standard"
        />
        <meta name="robots" content="max-video-preview:-1" />
      </Helmet>
      <FAQSchema faqs={faqs} />
      <div className="w-full flex justify-center items-center px-4 mt-20">
  <div className="w-full max-w-5xl h-auto object-contain rounded-lg shadow-md transition duration-300 hover:scale-105">
  <AdBanner displayOrder="1" />
  </div>
</div>
      <div className="w-full flex flex-col items-center ">
        <div className="w-full flex flex-col items-center ">
          <div className=" mt-10 w-full flex flex-col items-center justify-center bg-black h-[200px] md:h-[300px] shadow-lg mb-5 border-b-8 border-blue-600">
            <h1 className="text-white text-4xl md:text-7xl text-center font-medium">
              RBL Bank Credit Cards
            </h1>
            <p className="text-gray-200 text-lg md:text-2xl pt-2 px-4 text-center">
              Experience financial freedom and flexibility with our credit card
              options.
            </p>
          </div>
        </div>
        <div className="flex justify-center items-center  p-4 ">
          <div className="bg-white shadow-lg rounded-2xl p-6 max-w-7xl text-center mt-4">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4">
              Unlock Everyday Rewards, Lifestyle Privileges & Smart EMI Benefits{" "}
            </h2>

            <p className="text-gray-600 leading-relaxed mt-3">
              RBL Bank offers a compelling range of credit cards designed to
              maximize your daily savings, lifestyle indulgences, and big-ticket
              purchases. Whether you're looking for cashback on groceries,
              accelerated rewards on online shopping, or privileges like free
              movie tickets and travel perks, RBL cards cater to both
              value-seekers and premium users. With a simplified rewards system
              and flexible EMI options, RBL cards are ideal for building a smart
              and rewarding credit profile.
            </p>
          </div>
        </div>

        <h2 className="text-center text-2xl md:text-3xl font-bold text-gray-800 my-10">
          Featured Credit Cards
        </h2>
        <div className="w-[95%] mx-auto flex gap-5 flex-wrap md:flex-nowrap justify-center mb-10">
          <div className="w-fit flex flex-col gap-8">
            {currentCards &&
              currentCards.map((item, index) => {
                return (
                  <>
                    {" "}
                    <CardComponent
                    key={index}
                    cardDetails={item}
                    Card_features={item?.Card_features}
                    fees={item?.fees}
                    cardName={item?.title}
                    cardImage={item?.image}
                    rating={item?.rating}
                    category={item?.category}
                    status={item?.status}
                    bank_link={item?.bank_link}
                    />{" "}
                  </>
                );
              })}
          </div>

           <div className="w-full relative ">
                     <div className="sticky overflow-hidden top-20 w-full h-[500px] flex flex-col justify-between">
                       {/* <div className="w-[70%] mx-auto">
                                                  <h2 className="text-center font-medium pt-5 text-lg">
                                                    <span className="font-semibold text-white">816 people</span>{" "}
                                                    are on call with our advisors right now
                                                  </h2>
                                                </div> */}
                       <div className="w-full mx-auto">
                      
                           <div className="w-[80%] mx-auto ">
                           <AdBanner displayOrder="2" />                           </div>
                        
                         <div className="bg-white">
                           {/* <h3 className="text-center text-blue-500 cursor-pointer font-semibold py-2">
                                                      Know your advisor
                                                    </h3> */}
                         </div>
                       </div>
                     </div>
                   </div>
                 </div>
        {/* Pagination */}
        <ul className="flex justify-center mt-4">
          {currentCards &&
            CreditCardData.cards?.filter(
              (card) => card.category === "Credit card"
            ).length > 0 &&
            Math.ceil(
              CreditCardData.cards?.filter(
                (card) => card.category === "Credit card"
              ).length / cardsPerPage
            ) > 1 &&
            Array.from({
              length: Math.ceil(
                CreditCardData.cards?.filter(
                  (card) => card.category === "Credit card"
                ).length / cardsPerPage
              ),
            }).map((_, index) => (
              <li key={index} className="mx-1">
                <button
                  className={`px-3 py-1 rounded-lg ${
                    currentPage === index + 1
                      ? "bg-blue-500 text-white"
                      : "bg-gray-200 text-gray-800"
                  }`}
                  onClick={() => paginate(index + 1)}
                >
                  {index + 1}
                </button>
              </li>
            ))}
        </ul>

        
        {/* <div className='w-[95%] py-10'>
                                         <h1 className='text-center font-bold text-5xl my-10'>Frequently Asked Questions</h1>
                                         <AccordionComponent />
                                     </div> */}

        <div className="w-full px-2 py-2 bg-gradient-to-br from-sky-50 via-white to-sky-100 dark:from-gray-900 dark:to-gray-800">
          <div className="max-w-6xl mx-auto grid gap-10">
            <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-lg p-6 md:p-10 border border-sky-200 dark:border-gray-700 hover:shadow-xl transition-shadow">
              <div className="flex items-center gap-3 mb-6">
                <FileText className="w-8 h-8 text-sky-600" />
                <span className="text-2xl md:text-3xl font-bold text-gray-800 dark:text-white">
                  Eligibility Criteria to Apply for RBL Credit Card
                </span>
              </div>
              <div className="grid sm:grid-cols-2 gap-6 text-gray-700 dark:text-gray-300">
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Minimum Age Requirement
                  </span>
                  <span>
                    {" "}
                    The primary cardholder should be at least 21 years old.
                    Add-on cardholders can be 18 years or older.{" "}
                  </span>
                </div>

                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Monthly Income Criteria
                  </span>
                  <span>
                    {" "}
                    A minimum monthly income of ₹25,000–₹30,000 is required.
                    High-end cards may need higher income proofs.
                  </span>{" "}
                </div>
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Credit Score Standards
                  </span>
                  <span>
                    {" "}
                    A healthy CIBIL score of 750+ with a history of on-time
                    payments is crucial for approval and better credit limits.{" "}
                  </span>
                </div>
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Applicable Locations
                  </span>
                  <span>
                    {" "}
                    RBL credit cards are issued in metro cities and selected
                    urban areas. Your address must fall within eligible service
                    zones.{" "}
                  </span>
                </div>
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Employment Type Eligibility
                  </span>
                  <span>
                    {" "}
                    Both salaried individuals with stable job history and
                    self-employed professionals with verifiable income documents
                    can apply.
                  </span>
                </div>
              </div>
            </div>

            <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-lg p-6 md:p-10 border border-emerald-200 dark:border-gray-700 hover:shadow-xl transition-shadow">
              <div className="flex items-center gap-3 mb-6">
                <BadgeCheck className="w-8 h-8 text-emerald-600" />
                <span className="text-2xl md:text-3xl font-bold text-gray-800 dark:text-white">
                  Documents Required to Apply for RBL Credit Card
                </span>
              </div>
              <div className="grid sm:grid-cols-2 gap-6 text-gray-700 dark:text-gray-300">
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Valid Identity Proof
                  </span>
                  <span>
                    {" "}
                    Submit any government-issued ID like Aadhaar, PAN, Passport,
                    or Driving License with photo and matching name.
                  </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Address Proof
                  </span>
                  <span>
                    {" "}
                    Acceptable documents include recent utility bills, Aadhaar,
                    bank passbook, or rental agreements showing current
                    residence.
                  </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Income Proof
                  </span>
                  <span>
                    {" "}
                    Salaried: Salary slips of last 3 months or Form 16.
                    Self-Employed: Latest 2 years’ ITR, business income proofs,
                    and audited financials.
                  </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Passport Size Photo
                  </span>
                  <span>
                    {" "}
                    A recent color photo is required for KYC and card
                    documentation.
                  </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl sm:col-span-2">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    PAN Card Copy
                  </span>
                  <span>
                    {" "}
                    Mandatory for credit evaluation and regulatory compliance.{" "}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="w-full flex justify-center items-center my-6 px-4">
          <div className="w-full max-w-[984px]">

     
        <AdBanner displayOrder="3" />
        </div>
         
        </div>
      <div className="px-4 py-10 md:px-8 max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-800 text-center mb-4">
          How to Apply for RBL Credit Card
        </h2>
        {/* <p className="text-gray-600 text-sm md:text-base mt-2 text-center mb-8">
                                   Applying for a fuel credit card is a seamless process that starts with
                                   the right research and ends at the official bank’s platform for final
                                   submission. Here’s how you can get started through TheFinMaster.com:
                                 </p> */}
        <div className="grid gap-6 md:grid-cols-2">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              className="flex items-start gap-4 p-4 rounded-xl bg-white dark:bg-gray-900 shadow-md border hover:shadow-lg transition"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <div className="mt-1">{step.icon}</div>
              <div>
                <h3 className="text-lg font-semibold text-gray-800 dark:text-white mb-1">{`${
                  index + 1
                }. ${step.title}`}</h3>
                <p className="text-md text-gray-600 dark:text-gray-300">
                  {step.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
      <div className="max-w-4xl mx-auto py-6 px-2">
        <h2 className="text-2xl md:text-3xl font-semibold text-center mb-8">
          Frequently Asked Questions
        </h2>
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border rounded-lg overflow-hidden shadow-md"
            >
              <button
                onClick={() => toggleAccordion(index)}
                className="w-full p-4 text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
              >
                {faq.question}
                <Icon id={index} open={activeIndex} />
              </button>
              {activeIndex === index && (
                <div className="p-4 bg-gray-100">
                  <p className="text-gray-700">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Rbl;
